import React, { useEffect, useState } from 'react';
import { fetchSmsArchive, fetchBalances } from '../services/backend-expenses';
import { getUser } from '../services/auth';
import api from '../api';

const SmsArchive = () => {
  const telegramId = getUser()?.telegram_id;
  const [messages, setMessages] = useState([]);
  const [banks, setBanks] = useState([]);
  const [bankName, setBankName] = useState('All');
  const [parsed, setParsed] = useState('');
  const [search, setSearch] = useState('');
  const [testingId, setTestingId] = useState(null);
  const [testResult, setTestResult] = useState({});

  const load = async () => {
    const msgs = await fetchSmsArchive(telegramId, { bankName, parsed: parsed===''? undefined : parsed, search, limit: 200, offset: 0 });
    const bals = await fetchBalances(telegramId);
    setMessages(msgs);
    setBanks(bals.map(b=>b.bank_name));
  };

  useEffect(()=>{ if(telegramId) load(); /* eslint-disable-next-line */ },[telegramId, bankName, parsed]);

  const onTestParse = async (m) => {
    setTestingId(m.id);
    setTestResult(r=>({ ...r, [m.id]: 'Testing...' }));
    try {
      const { data } = await api.post('/api/expenses/sms-archive/test-parse', { message: m.message_text });
      setTestResult(r=>({ ...r, [m.id]: JSON.stringify(data.parsed, null, 2) }));
    } catch (e) {
      setTestResult(r=>({ ...r, [m.id]: 'Error' }));
    } finally {
      setTestingId(null);
    }
  };

  return (
    <div>
      <h1>SMS Archive</h1>
      <div className="card">
        <div className="filters">
          <div>
            <label>Bank</label>
            <select className="input" value={bankName} onChange={e=>setBankName(e.target.value)}>
              <option>All</option>
              {banks.map(b=>(<option key={b}>{b}</option>))}
            </select>
          </div>
          <div>
            <label>Parsed</label>
            <select className="input" value={parsed} onChange={e=>setParsed(e.target.value)}>
              <option value="">All</option>
              <option value="1">Parsed</option>
              <option value="0">Unparsed</option>
            </select>
          </div>
          <div style={{flex:1}}>
            <label>Search</label>
            <input className="input" value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search text" />
          </div>
          <div style={{alignSelf:'flex-end'}}>
            <button className="btn" onClick={load}>Refresh</button>
          </div>
        </div>
      </div>

      <div className="card">
        <h3>Messages ({messages.length})</h3>
        <div className="table-wrapper">
          <table className="table">
            <thead>
              <tr><th>Time</th><th>Bank</th><th>Parsed</th><th>Message</th><th>Actions</th><th>Test Result</th></tr>
            </thead>
            <tbody>
              {messages.map(m => (
                <tr key={m.id}>
                  <td>{m.created_at}</td>
                  <td>{m.bank_name || '-'}</td>
                  <td>{m.parsed_success ? 'Yes' : 'No'}</td>
                  <td style={{maxWidth: 400}}>{m.message_text}</td>
                  <td>
                    <button className="btn secondary" onClick={()=>onTestParse(m)} disabled={testingId===m.id}>Test Parse</button>
                  </td>
                  <td style={{maxWidth: 400}}>
                    {testResult[m.id] && <pre className="small" style={{whiteSpace:'pre-wrap'}}>{testResult[m.id]}</pre>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SmsArchive; 